module.exports = __webpack_public_path__ + "img/page-063.a6bfda88.jpg";